<template>
  <div id="app">
    <!-- <Navbar /> -->
    <router-view />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import './App.css'

export default {
  name: 'App',
  component: {
    Navbar
  }
}
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* background-color: rgba(71, 70, 70, 0.582); */
  overflow: hidden;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

</style>
